/* eslint-disable camelcase */
import error_messages from "./error-messages";
import errorIcon from "../images/error-icon.png";
import journey_properties from "../utils/journeyProperties";
import { getLoginEndpoint } from "../utils/getEndpoints";
import { setUnifiedError, removeUnifiedError } from "./partnerCentralUtils";

const getRealm = () => {
  return journey_properties.realm;
};

const getAppId = () => {
  return journey_properties.appID;
};

const getUsername = () => {
  return document.getElementById("username").value;
};

const getPassword = () => {
  return document.getElementById("password").value;
};

const getJourneyId = () => {
  return document.getElementById("journey").value;
};

const getContainer = () => {
  return document.getElementById("transmitContainer");
};

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

/** get Ping Federate Resume URL from param JWT **/
const getResumeURL = (payload) => {
  const cburl = payload.baseCallbackUrl;
  if (cburl.length - 1 === cburl.lastIndexOf("/")) {
    return cburl.substring(0, cburl.lastIndexOf("/")) + payload.resumePath;
  } else {
    return cburl + payload.resumePath;
  }
};

const redirectToLogin = () => {
  location.replace(getLoginEndpoint());
};

const isEmpty = (s) => {
  return !s || s.trim().length === 0;
};

/** Validate password fields on the Reset Password Page */
const passwordFieldsValidation = (new_pswd, confirm_pswd) => {
  const new_pswd_label = document.getElementById("new-pswd-label");
  const confirm_pswd_label = document.getElementById("confirm-pswd-label");

  const new_pswd_field = document.getElementById("new_pswd");
  const confirm_pswd_field = document.getElementById("confirm_pswd");

  const new_pswd_error = document.getElementById("new-pswd-error-msg");
  const confirm_pswd_error = document.getElementById("confirm-pswd-error-msg");

  const element = document.getElementById("pswd-reset-error-banner");
  const isDeveloperPortal = !window.location.href.includes("partner-login");

  if (isDeveloperPortal) {
    removeResetPswdTextFieldErrors();
    if (isEmpty(new_pswd) && isEmpty(confirm_pswd)) {
      setTxtFieldError(
        new_pswd_field,
        new_pswd_error,
        "Enter password",
        new_pswd_label
      );
      setTxtFieldError(
        confirm_pswd_field,
        confirm_pswd_error,
        "Confirm password",
        confirm_pswd_label
      );
      return false;
    } else if (isEmpty(new_pswd)) {
      setTxtFieldError(
        new_pswd_field,
        new_pswd_error,
        "Enter password",
        new_pswd_label
      );
      return false;
    } else if (isEmpty(confirm_pswd)) {
      setTxtFieldError(
        confirm_pswd_field,
        confirm_pswd_error,
        "Confirm password",
        confirm_pswd_label
      );
      return false;
    } else if (new_pswd !== confirm_pswd) {
      setBannerError(error_messages.PSWDS_DO_NOT_MATCH, element);
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
};

/** Handle erros returned from authe for Reset Password Page */
const handleResetPasswordErrors = (errors) => {
  const recently_used_pswd = errors.some(
    (err) => err.code === "PASSWORD_RECENTLY_USED"
  );
  const element = document.getElementById("pswd-reset-error-banner");
  setUnifiedError(
    recently_used_pswd
      ? error_messages.PSWD_RECENTLY_USED
      : error_messages.INVALID_PSWD
  );
};

/** Validate the email address on the Password Help Page */
const emailFieldValidation = (emailAddress) => {
  if (isEmpty(emailAddress)) {
    setUnifiedError("Enter email address");
    return false;
  } else if (!validateEmail(emailAddress)) {
    setUnifiedError(error_messages.INVALID_EMAIL);
    return false;
  } else {
    removeUnifiedError();
    return true;
  }
};

const isOTPValid = () => {
  const txtfield = document.getElementById("otp");
  removeUnifiedError();
  if (txtfield.value.trim() !== "") {
    return true;
  }
  setUnifiedError("Enter OTP");
  return false;
};

const loginFormValidation = (username, password) => {
  const usernameLabel = document.getElementById("email-label");
  const pswdLabel = document.getElementById("pswd-label");

  const usernameField = document.getElementById("username");
  const passwordField = document.getElementById("password");
  const username_error = document.getElementById("email-error-msg");
  const pswd_error = document.getElementById("password-error-msg");

  removeLoginTexFieldErrors();
  if (isEmpty(username) && isEmpty(password)) {
    setTxtFieldError(
      usernameField,
      username_error,
      "Enter email address",
      usernameLabel
    );
    setTxtFieldError(passwordField, pswd_error, "Enter password", pswdLabel);
    return false;
  } else if (isEmpty(username)) {
    setTxtFieldError(
      usernameField,
      username_error,
      "Enter email address",
      usernameLabel
    );
    return false;
  } else if (isEmpty(password)) {
    setTxtFieldError(passwordField, pswd_error, "Enter password", pswdLabel);
    return false;
  } else {
    return true;
  }
};

const removeLoginTexFieldErrors = () => {
  const banner = document.getElementById("login-error-banner");
  const email_msg = document.getElementById("email-error-msg");
  const email_field = document.getElementById("username");

  const pswd_msg = document.getElementById("password-error-msg");
  const pswd_field = document.getElementById("password");

  const email_label = document.getElementById("email-label");
  const pswd_label = document.getElementById("pswd-label");
  removeFormErrors(
    [banner, email_msg, pswd_msg],
    [email_field, pswd_field],
    [email_label, pswd_label]
  );
};

const removePswdHelpError = () => {
  const banner = document.getElementById("pswd-help-banner");
  const error_msg = document.getElementById("emailAddress-error-msg");
  const txtfield = document.getElementById("form_username");
  const label = document.getElementById("emailAddress-label");
  removeFormErrors([banner, error_msg], [txtfield], [label]);
};

const removeResetPswdTextFieldErrors = () => {
  const new_pswd_field = document.getElementById("new_pswd");
  const confirm_pswd_field = document.getElementById("confirm_pswd");
  const new_pswd_msg = document.getElementById("new-pswd-error-msg");
  const confirm_pswd_msg = document.getElementById("confirm-pswd-error-msg");
  const banner = document.getElementById("pswd-reset-error-banner");
  const new_pswd_label = document.getElementById("new-pswd-label");
  const confirm_pswd_label = document.getElementById("confirm-pswd-label");
  removeFormErrors(
    [new_pswd_msg, confirm_pswd_msg, banner],
    [new_pswd_field, confirm_pswd_field],
    [new_pswd_label, confirm_pswd_label]
  );
};

const removeFormErrors = (errorMsgs, txtFields, labels) => {
  const doesNullExistInArray = (arr) => {
    return arr.some((i) => {
      return i === null;
    });
  };

  if (!doesNullExistInArray(errorMsgs)) {
    errorMsgs.forEach((element) => {
      element.innerHTML = "";
    });
  }

  if (!doesNullExistInArray(txtFields)) {
    txtFields.forEach((element) => {
      element.style.border = "1px solid #646464";
    });
  }

  if (!doesNullExistInArray(labels)) {
    labels.forEach((element) => {
      element.style.color = "#333333";
    });
  }
};

const setBannerError = (text, element) => {
  const error_banner = document.createElement("div");
  error_banner.className = "error-banner";

  const iconDiv = document.createElement("div");
  iconDiv.style.cssText = "display: flex;";
  const iconImg = document.createElement("img");
  iconImg.src = errorIcon;
  iconImg.className = "error-icon";
  iconImg.alt = "error-icon";
  iconImg.setAttribute("aria-label", "Error Icon");
  iconDiv.appendChild(iconImg);

  const errorDiv = document.createElement("div");
  const error_msg = document.createElement("p");
  error_msg.className = "banner-error-txt";
  error_msg.textContent = text;
  errorDiv.appendChild(error_msg);

  error_banner.appendChild(iconDiv);
  error_banner.appendChild(errorDiv);
  element.appendChild(error_banner);
};

const setTxtFieldError = (txtfield, element, text, label) => {
  label.style.color = "#BF2155";
  txtfield.style.border = "2px solid #BF2155";
  const iconImg = document.createElement("img");
  iconImg.src = errorIcon;
  iconImg.className = "error-icon";
  iconImg.alt = "error-icon";
  iconImg.setAttribute("aria-label", "Error Icon");
  const error_msg = document.createElement("p");
  error_msg.style.cssText = "margin-bottom: 0";
  error_msg.textContent = text;
  element.appendChild(iconImg);
  element.appendChild(error_msg);
};

const getErrorMessage = (data) => {
  if (data.assertion_error_code === 5 && data.additional_data.errors) {
    const errors = data.additional_data.errors;
    let isPswdInvalid = false;
    let isPswdExpired = false;
    let isPswdLocked = false;

    errors.map((err) => {
      if (err.code === "INVALID_CREDENTIALS") {
        isPswdInvalid = true;
      } else if (err.code === "PWD_CORRECT_BUT_EXPIRED") {
        isPswdExpired = true;
      } else if (err.code === "PASSWORD_LOCKED") {
        isPswdLocked = true;
      }
    });
    return isPswdInvalid
      ? error_messages.INVALID_PSWD
      : isPswdExpired
      ? error_messages.PSWD_EXPIRED
      : isPswdLocked
      ? error_messages.PSWD_LOCKED
      : error_messages.AUTHENTICATION_FAILED;
  } else {
    return error_messages.SERVER_ERROR;
  }
};

export {
  getRealm,
  getAppId,
  getUsername,
  getPassword,
  getJourneyId,
  getContainer,
  validateEmail,
  getResumeURL,
  redirectToLogin,
  passwordFieldsValidation,
  handleResetPasswordErrors,
  emailFieldValidation,
  loginFormValidation,
  removeLoginTexFieldErrors,
  removePswdHelpError,
  setBannerError,
  setTxtFieldError,
  getErrorMessage,
  removeResetPswdTextFieldErrors,
  isOTPValid,
};
